if (!customElements.get('product-section-navigation')) {
    customElements.define(
        'product-section-navigation',
        class extends HTMLElement {
            connectedCallback() {
                this.links = [...this.querySelectorAll('[data-section-nav-link]')];
                this.links.forEach((link) => {
                    link.addEventListener('click', (e) => this.onClick(e));
                });
                window.addEventListener('scroll', () => this.onScroll(), {
                    passive: true
                });
                this.onScroll();
            }
            getTarget(link) {
                const position = link.dataset.targetPosition || 'custom';
                if (position === 'product') {
                    return document.querySelector('[id$="__main"]');
                }
                if (position.startsWith('after_')) {
                    const index = Number(position.replace('after_', '')) - 1;
                    const section = this.closest('.shopify-section');
                    return [...section.parentElement.children]
                        .filter(
                            (el) =>
                                el.classList.contains('shopify-section') &&
                                el.compareDocumentPosition(section) &
                                    Node.DOCUMENT_POSITION_PRECEDING
                        )[index];
                }
                const id = link.dataset.target?.replace('#', '');
                return id ? document.getElementById(id) : null;
            }
            getOffset() {
                const header =
                    document.querySelector('[data-header-height]')?.offsetHeight || 0;
                return header + this.offsetHeight;
            }
            onClick(e) {
                const link = e.currentTarget;
                const target = this.getTarget(link);
                if (!target) return;
                e.preventDefault();
                window.scrollTo({
                    top:
                        window.scrollY +
                        target.getBoundingClientRect().top -
                        this.getOffset(),
                    behavior: 'auto'
                });
            }
            onScroll() {
                let active = this.links[0];
                const offset = this.getOffset() + 2;
                this.links.forEach((link) => {
                    const target = this.getTarget(link);
                    if (target?.getBoundingClientRect().top <= offset) {
                        active = link;
                    }
                });
                this.links.forEach((link) => {
                    link.classList.toggle('is-active', link === active);
                });
            }
        }
    );
}